import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  useAppKitAccount,
  useAppKit,
  useAppKitNetwork,
} from "@reown/appkit/react";
import { bsc } from "@reown/appkit/networks";
import useContract from "../hooks/useContract";

const Navbar = () => {
  const location = useLocation();
  const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();
  const { switchNetwork, chainId } = useAppKitNetwork();
  const { isAdmin } = useContract();

  const [openMenu, setOpenMenu] = useState(false);
  const [admin, setAdmin] = useState(false);

  // ✅ AUTO SWITCH BSC - CONSOLE ONLY
  useEffect(() => {
    if (isConnected && switchNetwork && chainId !== bsc.id) {
      console.log("🔄 Switching to BSC...");
      switchNetwork(bsc);
    }
  }, [isConnected, chainId, switchNetwork, bsc]);

  useEffect(() => {
    if (!address) {
      setAdmin(false);
      return;
    }
    const check = async () => {
      try {
        const res = await isAdmin();
        setAdmin(res);
      } catch {
        setAdmin(false);
      }
    };
    check();
  }, [address, isAdmin]);

  const menu = [
    { path: "/", label: "Home" },
    { path: "/dashboard", label: "Dashboard" },
    { path: "/packages", label: "Packages" },
    { path: "/airdrops", label: "Airdrops" },
    { path: "/income", label: "Income" },
    ...(admin ? [{ path: "/admin", label: "Admin" }] : []),
  ];

  return (
    <div className="w-full border-b border-gray-800 bg-black text-white relative">
      <div className="flex items-center justify-between px-5 md:px-8 py-4">
        <Link to="/" className="flex items-center gap-2">
          <img src="/kindlogo.png" className="h-10" />
          <span className="text-xl font-bold text-yellow-500">KindCat</span>
        </Link>
        <div className="hidden md:flex gap-6">
          {menu.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`px-4 py-2 rounded-xl text-white ${
                location.pathname === item.path ? "bg-yellow-600" : ""
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={() => open(isConnected ? "Account" : "Connect")}
            className="hidden md:block px-5 py-2.5 bg-yellow-600 rounded-xl font-semibold text-white"
          >
            {isConnected
              ? `${address.slice(0, 4)}...${address.slice(-4)}`
              : "Connect Wallet"}
          </button>
          <button onClick={() => setOpenMenu(true)} className="md:hidden text-white text-2xl">
            ☰
          </button>
        </div>
      </div>

      {openMenu && <div onClick={() => setOpenMenu(false)} className="fixed inset-0 bg-black/50 z-40" />}
      
      <div
        className={`fixed top-0 right-0 h-[100dvh] w-[80%] max-w-sm bg-black z-50 transform transition-transform duration-300 flex flex-col ${
          openMenu ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center p-5 border-b border-gray-800">
          <h2 className="text-white text-lg">Menu</h2>
          <button onClick={() => setOpenMenu(false)} className="text-white text-2xl">✕</button>
        </div>
        <div className="flex flex-col gap-3 p-5 flex-1 overflow-y-auto">
          {menu.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setOpenMenu(false)}
              className={`px-4 py-3 rounded-xl text-white ${
                location.pathname === item.path ? "bg-yellow-600" : ""
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
        <div className="p-5 border-t border-gray-800">
          <button
            onClick={() => {
              open(isConnected ? "Account" : "Connect");
              setOpenMenu(false);
            }}
            className="w-full bg-yellow-600 py-3 rounded-xl font-semibold text-white"
          >
            {isConnected
              ? `${address.slice(0, 4)}...${address.slice(-4)}`
              : "Connect Wallet"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;